import React from 'react';
import { useTranslation } from 'react-i18next';
import './Loaders.css';

const ProductCardSkeleton = () => (
    <div className="section-loader__card" aria-hidden="true">
        <div className="section-loader__shimmer section-loader__card-image" />
        <div className="section-loader__shimmer section-loader__card-line section-loader__card-line--title" />
        <div className="section-loader__shimmer section-loader__card-line section-loader__card-line--short" />
        <div className="section-loader__shimmer section-loader__card-line section-loader__card-line--price" />
    </div>
);

const HeroLoader = () => (
    <div className="section-loader--hero">
        <div className="section-loader__hero-slide">
            <div className="section-loader__hero-content container">
                <div className="section-loader__hero-img-box">
                    <div className="section-loader__shimmer section-loader__hero-image" />
                </div>
                <div className="section-loader__hero-text">
                    <div className="section-loader__shimmer section-loader__hero-line section-loader__hero-line--title" />
                    <div className="section-loader__shimmer section-loader__hero-line section-loader__hero-line--desc" />
                    <div className="section-loader__shimmer section-loader__hero-line section-loader__hero-line--desc section-loader__hero-line--short" />
                    <div className="section-loader__shimmer section-loader__hero-button" />
                </div>
            </div>
            <div className="section-loader__hero-pagination" aria-hidden="true">
                <span className="section-loader__hero-dot section-loader__hero-dot--active" />
                <span className="section-loader__hero-dot" />
            </div>
        </div>
    </div>
);

const BannerLoader = () => (
    <div className="section-loader--banner">
        <div className="section-loader__banner-grid container">
            <div className="section-loader__shimmer section-loader__banner-title" />
            <div className="section-loader__shimmer section-loader__banner-image" />
            <div className="section-loader__shimmer section-loader__banner-image" />
        </div>
    </div>
);

const PopularLoader = ({ count = 8 }) => (
    <div>
        <div className="section-loader__product-grid container grid">
            {Array.from({ length: count }, (_, index) => (
                <ProductCardSkeleton key={index} />
            ))}
        </div>
    </div>
);

const ProductsPageLoader = ({ count = 12 }) => (
    <div className="section-loader--products">
        <div className="product-list-container container">
            <div className="section-loader__product-header" aria-hidden="true">
                <div className="section-loader__shimmer section-loader__header-chip" />
                <div className="section-loader__shimmer section-loader__header-title" />
            </div>
            <div className="section-loader__product-grid grid">
                {Array.from({ length: count }, (_, index) => (
                    <ProductCardSkeleton key={index} />
                ))}
            </div>
        </div>
    </div>
);

const NewArrivalLoader = ({ count = 4 }) => (
    <div>
        <div className="section-loader__carousel container">
            {Array.from({ length: count }, (_, index) => (
                <ProductCardSkeleton key={index} />
            ))}
        </div>
    </div>
);

const GalleryLoader = () => (
    <div className="section-loader--gallery">
        <div className="section-loader__gallery-container">
            <div className="section-loader__shimmer section-loader__gallery-title" />
            <div className="section-loader__shimmer section-loader__gallery-frame" />
            <div className="section-loader__shimmer section-loader__gallery-arrow section-loader__gallery-arrow--left" aria-hidden="true" />
            <div className="section-loader__shimmer section-loader__gallery-arrow section-loader__gallery-arrow--right" aria-hidden="true" />
        </div>
    </div>
);

function Loaders({ variant = 'hero', count }) {
    const { t } = useTranslation();
    const resolvedCount = count ?? (
        variant === 'popular' || variant === 'products' ? 12 : 4
    );

    return (
        <div
            className={`section-loader-wrap section-loader-wrap--${variant}`}
            role="status"
            aria-live="polite"
            aria-busy="true"
            aria-label={t('a11y.loadingContent')}
        >
            {variant === 'hero' && <HeroLoader />}
            {variant === 'banner' && <BannerLoader />}
            {variant === 'popular' && <PopularLoader count={resolvedCount} />}
            {variant === 'products' && <ProductsPageLoader count={resolvedCount} />}
            {variant === 'newArrival' && <NewArrivalLoader count={resolvedCount} />}
            {variant === 'gallery' && <GalleryLoader />}
        </div>
    );
}

export default Loaders;
